import type { IconNode } from '../types';

/**
 * @name desk-lamp
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgNyAxLTIiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNCIgeD0iMTUiIHk9IjciIC8+CiAgPHBhdGggZD0iTTYgN3Y0IiAvPgogIDxwYXRoIGQ9Ik05IDdIM2wxLTVoNFoiIC8+CiAgPHBhdGggZD0iTTIyIDIyVjEyYzAtLjYtLjQtMS0xLTFIM2MtLjYgMC0xIC40LTEgMXYxMCIgLz4KICA8cGF0aCBkPSJNMTAgMTVIMiIgLz4KICA8cGF0aCBkPSJNMTAgMTF2OCIgLz4KICA8cGF0aCBkPSJNMjIgMTlIMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/desk-lamp
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const deskLamp: IconNode = [
  ['path', { d: 'm17 7 1-2', key: 'lw9mw' }],
  ['rect', { width: '4', height: '4', x: '15', y: '7', key: '1jqa9o' }],
  ['path', { d: 'M6 7v4', key: 'mtt5p0' }],
  ['path', { d: 'M9 7H3l1-5h4Z', key: 'oih2pt' }],
  ['path', { d: 'M22 22V12c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v10', key: 'x1ucem' }],
  ['path', { d: 'M10 15H2', key: '1vwyk2' }],
  ['path', { d: 'M10 11v8', key: 'tzc2wo' }],
  ['path', { d: 'M22 19H2', key: 'nuriw5' }],
];

export default deskLamp;
